<script setup>
import Pill from '@/Components/Pill.vue';

defineProps({
  actionType: Object
});
</script>

<template>
  <Pill :variant="actionType.color">
    <slot />
  </Pill>
</template>
